import { FloatingNode, FloatingPortal, safePolygon } from '@floating-ui/react'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { HTML_ELEMENT_THEME_PROVIDER_ID } from '../../../constants/html'
import { useFloatingTooltip } from '../../../hooks'
import { FloatingTooltipTrigger } from '../../Floating'
import { ICON_HEIGHT_16, IconNG } from '../../Icon'
import {
  FIELD_VARIABLE_INFO_HOVER_DELAY,
  QA_NAME_FIELD_VARIABLE_INFO,
} from '../FieldVariable.constants'
import { FieldVariableCard } from '../FieldVariableCard'

import InfoIcon from '../../../icons/info.svg'

function FieldVariableInfo({ fieldVariables }) {
  const { context, floatingStyles, getReferenceProps, isOpen, nodeId, refs } =
    useFloatingTooltip({
      hoverConfig: {
        delay: FIELD_VARIABLE_INFO_HOVER_DELAY,
        handleClose: safePolygon(),
        move: false,
      },
      placement: FLOATING_ELEMENT_PLACEMENT.top,
    })

  const { setFloating, setPositionReference } = refs

  // The mockups center the card over the row the icon sits in, not the icon.
  function handleSetIconRef(icon) {
    setPositionReference(icon?.parentElement ?? null)
  }

  return (
    <>
      <FloatingTooltipTrigger
        context={context}
        getReferenceProps={getReferenceProps}
        ref={handleSetIconRef}
      >
        <IconNG
          Icon={InfoIcon}
          qaName={QA_NAME_FIELD_VARIABLE_INFO}
          size={ICON_HEIGHT_16}
        />
      </FloatingTooltipTrigger>
      <FloatingNode id={nodeId}>
        {isOpen ? (
          <FloatingPortal id={HTML_ELEMENT_THEME_PROVIDER_ID}>
            <FieldVariableCard
              fieldVariables={fieldVariables}
              ref={setFloating}
              style={floatingStyles}
            />
          </FloatingPortal>
        ) : null}
      </FloatingNode>
    </>
  )
}

export default FieldVariableInfo
